import { Box, Tag, TagLabel } from '@chakra-ui/react';
import { IOrderStatusContent } from '../../../interfaces/index';
import { useTranslation } from 'react-i18next';

interface Props {
    orderStatus: IOrderStatusContent;
    hideName?: boolean;
}

export default function OrderStatus({ orderStatus, hideName = false }: Props) {
    const [t] = useTranslation();

    return (
        <Tag
            size="sm"
            minWidth={hideName ? 'fit-content' : '120px'}
            variant="unstyled"
            color="#fff"
            borderColor={'#fff'}
            borderWidth="1px"
            display="flex"
            alignItems="center"
            gap="5px"
            padding="7px 12px">
            {orderStatus?.createIcon && orderStatus.createIcon()}
            <Box width="100%" display="flex" justifyContent="center" color="#fff">
                {!hideName && <TagLabel>{t(orderStatus?.localeName ?? '')}</TagLabel>}
            </Box>
        </Tag>
    );
}
